import {
  Edit,
  SimpleForm,
  DateField,
  Labeled,
  ReferenceArrayField,
  Datagrid,
  TextField,
  BooleanField,
} from "react-admin";
import { CircleOutlined, ErrorOutline } from "@mui/icons-material";
import { Divider } from "@mui/material";

import { sanitizeServiceBooking } from "./ServiceBookingCreate";
import useUpdateWithValidation from "../common/useUpdateWithValidation";
import ServiceBookingFields from "./fields";
import { invoiceExportRowStyle } from "../invoiceExports/InvoiceExportList";

const ServiceBookingEdit = () => {
  const save = useUpdateWithValidation("ServiceBooking", {
    redirectTo: "list",
    transform: sanitizeServiceBooking,
  });

  return (
    <Edit>
      <SimpleForm
        onSubmit={save}
        defaultValues={{
          canceledOn: null,
          invoicedUntil: null,
        }}
      >
        <ServiceBookingFields />

        <Divider style={{ marginBottom: "3em" }} />

        <Labeled>
          <ReferenceArrayField
            reference="InvoiceExport"
            source="invoiceExportIds"
            sort={{ field: "createdAt", order: "DESC" }}
            perPage={5}
          >
            <Datagrid
              bulkActionButtons={false}
              rowClick="show"
              rowStyle={invoiceExportRowStyle}
            >
              <TextField source="invoiceNumber" />

              <BooleanField
                source="failed"
                FalseIcon={CircleOutlined}
                TrueIcon={ErrorOutline}
                textAlign="center"
              />

              <DateField source="createdAt" />
            </Datagrid>
          </ReferenceArrayField>
        </Labeled>

        <Divider style={{ marginBottom: "3em" }} />

        <Labeled>
          <DateField source="createdAt" showTime />
        </Labeled>
        <Labeled>
          <DateField source="updatedAt" showTime />
        </Labeled>
      </SimpleForm>
    </Edit>
  );
};

export default ServiceBookingEdit;
